import { BIG_JOKER, SMALL_JOKER, cardSvg } from '../cards';
import { landlordHatMarkup } from '../ddzHat';
import { coverBg, fade, mix, n, rng, shadowInk, star, tint, warm, type ArtPal } from './kit';

/**
 * Dou Dizhu (斗地主): a fan of five cards — A♥, the pair of twos and the rocket (王炸: the small and the big joker, the
 * big one on top) — with the landlord's skullcap (地主) resting at its foot, a warm gold glow and a few sparkles.
 * The cards and the hat are the game's own art (art/cards.ts, art/ddzHat.ts), inlined with their own id prefixes.
 * No text, no glyphs, no chips or felt; five cards, not four (docs/art-prompts.md).
 */
export function doudizhuCover(P: ArtPal, p: string): string {
  const cx = 414;
  const cy = 196;
  const top = P.dark ? mix(P.bg, P.red, 0.14) : tint(P.red, 0.9);
  const mid = P.dark ? mix(P.panel, P.gold, 0.07) : tint(P.gold, 0.86);
  const bg = coverBg(p, P, top, mid, P.bg, [cx, cy]);
  const theme = P.dark ? 'dark' : 'light';
  const inner = (card: number, id: string) => cardSvg(card, theme, `${p}${id}`).replace(/^<svg[^>]*>/, '').replace(/<\/svg>$/, '');
  // 100 × 140 card art scaled ×1.34, rotated around a point below the fan
  const place = (card: number, id: string, angle: number) =>
    `<g transform="rotate(${angle} ${cx} ${cy + 170}) translate(${n(cx - 67)} ${cy - 104}) scale(1.34)">${inner(card, id)}</g>`;
  const r = rng(53);
  let sparks = '';
  for (let i = 0; i < 11; i++) {
    const a = r() * Math.PI * 2;
    const d = 160 + r() * 60;
    sparks += `<polygon points="${star(cx + Math.cos(a) * d, cy - 10 + Math.sin(a) * d * 0.58, 4 + r() * 5, 1.5 + r(), 4)}" fill="${i % 2 ? warm(P) : tint(warm(P), 0.4)}"/>`;
  }
  const hat = `<g transform="translate(500 284) rotate(-8 44 44) scale(2.6)">${landlordHatMarkup(P, `${p}h`)}</g>`;
  return (
    `<defs>${bg.defs}${fade(`${p}sh`, shadowInk(P), P.dark ? 0.5 : 0.16)}${fade(`${p}gw`, warm(P), P.dark ? 0.45 : 0.4)}` +
    `${fade(`${p}rw`, P.red, P.dark ? 0.35 : 0.22)}</defs>` +
    bg.body +
    `<ellipse cx="${cx + 20}" cy="${cy + 150}" rx="190" ry="16" fill="url(#${p}sh)"/>` +
    `<ellipse cx="${cx}" cy="${cy - 10}" rx="200" ry="150" fill="url(#${p}gw)"/>` +
    `<ellipse cx="${cx + 70}" cy="${cy - 30}" rx="120" ry="110" fill="url(#${p}rw)"/>` +
    sparks +
    place(49, 'a', -26) + // A♥
    place(0, 's', -13) + // 2♠
    place(1, 'h', 0) + // 2♥
    place(SMALL_JOKER, 'j', 13) +
    place(BIG_JOKER, 'k', 26) +
    hat
  );
}
